import { Component, Input, OnInit } from '@angular/core';
import { Item } from '../../../models/Item';
import { SummaryItem } from '../../../models/SummaryItem';
import { GlobalService } from '../../../services/global';
import { HttpService } from '../../../services/HttpService';

@Component({
  selector: 'app-item-summary',
  templateUrl: './item-summary.component.html',
  styleUrls: ['./item-summary.component.css']
})
export class ItemSummaryComponent implements OnInit {
  @Input() selectionSummary: string;
  @Input() configString: string;
  SummaryItems: SummaryItem[];
  Item: Item;
  constructor(private http:HttpService, private global:GlobalService) { }

  ngOnInit(): void {
    if (this.Item != null) {
      this.global.getCurrentUser().then(x => {
        var curUser = x;
        this.http.PostUserActivity(curUser.UserId.toString(), "Item Summary", "Load", this.Item.Item);
      });

      this.selectionSummary = this.Item.SelectionSummary;
      this.buildSelectionSummary();
    }
  }

  buildSelectionSummary() {
    this.SummaryItems = [];
    if (this.selectionSummary && this.selectionSummary.length > 0) {
      var firstSplit = this.selectionSummary.split('<br />');
      var spanRegex = /<\/?span>/g;
      for (var i = 0; i < firstSplit.length; i++) {
        var cleanSpans = firstSplit[i].replace(spanRegex, '');
        var colonSplit = cleanSpans.split(':');
        var newSummaryItem = new SummaryItem();
        newSummaryItem.Header = colonSplit[0].replace('[', '').replace(']', '');
        if (colonSplit.length == 2) {
          newSummaryItem.Description = colonSplit[1];
        }
        else if(colonSplit.length > 2) {
          newSummaryItem.Description = colonSplit[1] + ':' + colonSplit[2];
        }
        
        this.SummaryItems.push(newSummaryItem);

      }
    }
  }

}
